import Model from './BaseModel';
import AdminUser from './AdminUser';

export default class UserNote extends Model {
	resourceName() {
		return 'user_notes';
	}

	fields() {
		return ['note', 'note_category_id', 'created_at'];
	}

	relationships() {
		return {
			admin_user: new AdminUser()
		};
	}

	create(data) {
		return this.makePersistRequest({
			url: this.resourceUrl(),
			method: 'POST',
			data
		});
	}
}
